import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SearchHistoryKind, SearchHistoryListResponse } from 'src/typings';

/** Глобальная история запросов поисковой строки CRM (общая для всех менеджеров). */
@Injectable({
  providedIn: 'root'
})
export class SearchHistoryService {
  constructor(private http: HttpClient) {}

  record(query: string, kind?: SearchHistoryKind, label?: string): Observable<void> {
    return this.http.post<void>(`${environment.BACKEND}/search-history`, {
      query,
      kind,
      label
    });
  }

  list(query?: string): Observable<SearchHistoryListResponse> {
    let params = new HttpParams();
    if (query?.trim()) {
      params = params.set('query', query.trim());
    }
    return this.http.get<SearchHistoryListResponse>(`${environment.BACKEND}/search-history`, {
      params
    });
  }

  remove(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.BACKEND}/search-history/${id}`);
  }
}
